import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import BasicModal from '__components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';

type ConfrimModalProps = {
  recordCount: number;
  objectName: string;
  onConfirm(): void;
  onHide(): void;
};

const StyledText = styled(KizenTypography)`
  word-break: break-word;
`;

export const DeleteConfirmationModal = ({
  recordCount,
  objectName,
  onHide,
  onConfirm,
}: ConfrimModalProps) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      show
      size="small"
      typeOfContent="text"
      leftBtn={recordCount ? null : undefined}
      heading={
        recordCount
          ? t('Archive Records Before Deleting')
          : t('Please Confirm Deletion')
      }
      buttonText={recordCount ? t('Close') : t('Delete')}
      actionBtnColor={recordCount ? 'blue' : 'red'}
      onConfirm={recordCount ? onHide : onConfirm}
      onHide={onHide}
    >
      <StyledText>
        {recordCount
          ? t(
              'To delete {{ objectName }} Object, archive all its records first.',
              {
                objectName,
              }
            )
          : t(
              'Object {{ objectName }} will be deleted. This operation cannot be undone.',
              {
                objectName,
              }
            )}
      </StyledText>
    </BasicModal>
  );
};
